<template>
  <DashboardCard
    :error="error"
    :working="working"
    :showLink="showLink && !linkByItem"
    :linkRoute="linkRoute"
    :showSettings="showSettings"
    :user="user"
    :title="title"
    :subTitle="subTitle"
    @settings="invokeSettings"
    @link="invokeLink"
  >
    <v-chart
      ref="chart"
      :theme="theme"
      autoresize
      :option="options"
      :update-options="updateOptions"
      @click="chartClicked"
    ></v-chart>
  </DashboardCard>
</template>
<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import VChart from 'vue-echarts'
import itusTheme1 from './itus-1.project.json'
import itusTheme2 from './itus-2.project.json'
import itusTheme3 from './itus-3.project.json'
import itusTheme4 from './itus-4.project.json'
import itusTheme5 from './itus-5.project.json'
import DashboardCard from './DashboardCard'
import { DynamicLink } from './DynamicLink'

use([CanvasRenderer, PieChart, BarChart, LineChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent])

export default {
  name: 'ChartCard',
  components: {
    VChart,
    DashboardCard
  },
  props: {
    themeVariant: {
      type: Number,
      description: 'Theme variant number',
      default: 1
    },
    showLink: {
      type: Boolean,
      description: 'Controls visibility of the link icon.',
      default: false
    },
    linkRoute: {
      type: String,
      description: 'Route to use when showing link button.',
      default: ''
    },
    showSettings: {
      type: Boolean,
      description: 'Controls visiblity of the settings icon.',
      default: false
    },
    user: {
      type: Object,
      description: 'The user in context'
    },
    title: {
      type: String,
      description: 'Card title',
      default: ''
    },
    subTitle: {
      type: String,
      description: 'Card subtitle',
      default: ''
    },
    error: {
      type: Object,
      description: 'Error object if error during load.',
      default: function () {
        return null
      }
    },
    type: {
      type: String,
      description: 'Type of query chart: area, bar, line, or pie',
      default: 'bar'
    },
    chartHelper: Object,
    working: {
      type: Boolean,
      default: true
    },
    options: Object,
    updateOptions: {
      type: Object,
      description:
        'Options for to echarts.setOption when the options prop changes (https://github.com/ecomfe/vue-echarts)'
    }
  },
  computed: {
    theme: function () {
      switch (this.themeVariant) {
        case 1:
          return itusTheme1.theme
        case 2:
          return itusTheme2.theme
        case 3:
          return itusTheme3.theme
        case 4:
          return itusTheme4.theme
        default:
          return itusTheme5.theme
      }
    },
    linkByItem: function () {
      if (!this.linkRoute || !this.showLink) return false

      let dynamicLink = new DynamicLink(this.linkRoute)
      return dynamicLink.isItemLink
    }
  },
  methods: {
    chartClicked: function (params) {
      if (this.linkByItem) {
        let dynamicLink = new DynamicLink(this.linkRoute)

        if (this.type === 'pie' || this.type === 'bar') {
          this.$emit('link', dynamicLink.buildLink(params.data.row))
        } else {
          this.$emit('link', dynamicLink.buildLink(params.data[2]))
        }
      }
    },
    invokeSettings: function () {
      this.$emit('settings')
    },
    invokeLink: function () {
      this.$emit('link', this.linkRoute)
    }
  }
}
</script>
<style lang="css" scoped>
.full-header {
  width: 100%;
}
.echarts {
  height: 250px;
}
</style>
